<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="AgentId">
              <a-input
                placeholder="输入AgentId查询"
                v-model="queryParam.agentId"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="应用名称">
              <a-input
                placeholder="请输入应用名称"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="应用类型">
              <a-select v-model="queryParam.type" placeholder="请选择">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="1">自建应用</a-select-option>
                <a-select-option value="2">官方应用</a-select-option>
                <a-select-option value="3">小程序</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增应用</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <!--下拉栏显示的菜单， 通过slot="overlay"控制-->
        <a-menu slot="overlay">
          <!--  批量删除操作        -->
          <a-menu-item @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <!--下拉菜单的默认显示结束-->
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.agentid"
        @change="handleTableChange"
      >
        <template slot="avatarslot" slot-scope="text, record">
          <div class="anty-img-wrap">
            <a-avatar shape="square" icon="read" :src="text" />
          </div>
        </template>

        <span slot="custNum" slot-scope="text, record">
          <router-link
            :to="{
              path: '/wechatwork/customer/wxCustomerList',
              query: { userId: record.userId }
            }"
            >{{ text }}</router-link
          >
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a @click="handleView(record)">查看</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDeleteApp(record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <agent-modal ref="modalForm" @ok="modalFormOk"></agent-modal>
  </a-card>
</template>

<script>
import AgentModal from './AgentModal';
import { getFileAccessHttpUrl, postAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import {
  editApplication,
  deleteApplication,
  createApplication
} from '@/api/api';

export default {
  inject: ['reload'],
  name: 'AgentList',
  mixins: [JeecgListMixin],
  components: {
    AgentModal
  },
  data() {
    return {
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        {
          title: 'AgentId',
          align: 'center',
          dataIndex: 'agentid',
          width: 120
        },
        {
          title: '应用名称',
          align: 'center',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '应用描述',
          align: 'center',
          width: 120,
          dataIndex: 'description'
        },
        {
          title: '应用头像',
          align: 'center',
          width: 130,
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatarslot' }
        },
        {
          title: '应用类型',
          align: 'center',
          width: 80,
          dataIndex: 'type',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '自建应用';
            } else if (text == 2) {
              return '官方应用';
            } else if (text == 3) {
              return '小程序';
            } else {
              return text;
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 170
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/application/data',
        delete:
          process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/market/userDelete',
        deleteBatch:
          process.env.VUE_APP_CMS_WECHATWORK +
          '/wechatwork/application/deleteBatch'
      }
    };
  },
  computed: {},
  methods: {
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    handleMenuClick(e) {
      console.log('点击批量删除按钮');
      if (e.key === '1') {
        console.log('批量删除');
        this.batchDel();
      }
    },
    handleView(record) {
      this.$refs.modalForm.viewInfo(record);
    },
    //批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var agents = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          agents += this.selectionRows[a].agentid + ',';
        }
        console.log(agents, 1111);
        console.log(this.selectionRows);
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { agents: agents })
              .then(res => {
                if (res.errcode == 0) {
                  that.$message.success(res.errmsg);
                } else {
                  that.$message.error(res.errmsg);
                }
              })
              .finally(() => {
                that.loading = false;
                that.reload();
              });
          }
        });
      }
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    handleDeleteApp(record) {
      const that = this;
      // let formData = new FormData();
      // formData.agentId = record.agentid;
      deleteApplication({ agentId: record.agentid }).then(res => {
        if (res.errcode == 0) {
          that.$message.success(res.errmsg);
          that.reload();
        } else {
          that.$message.error(res.errmsg);
          that.reload();
        }
      });
    },
    JumpChatInfoview(record) {
      console.log(record);
      this.$router.push({
        path: '/wechatwork/agent/AgentList',
        query: { id: record.userId, type: 1 }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
